import styled from 'styled-components'

export const DocasStylesManager = styled.div`
  .ant-tabs-nav {
    margin-bottom: 0 !important;
  }

  .ant-form-item {
    margin-bottom: 10px;
  }

  .card-agenda-data {
    height: 35px;
    margin-bottom: 2px;
    width: 100%;
    .ant-card-body {
      padding: 5px 0;
      text-align: center;
    }
  }

  .doca-agenda-header {
    width: 100%;
    margin: 0 2px 0 4px;
    height: 35px;
    .ant-card-body {
      padding: 5px 0px;
      text-align: center;
    }

    &.is-now {
      background: #c4ccd3;
    }
  }

  .card-doca-nome {
    width: 100%;
    margin-bottom: 4px;
    .ant-card-body {
      padding: 4px;
      height: 90px;
    }
  }

  .card-agendamento {
    .ant-card-body {
      padding: 4px;
      height: 90px;
    }
    .agendaLabels {
      margin: 0;
      font-size: 12px;
    }

    &.card-status-1 {
      border: 1px solid rgb(172, 169, 5);
      border-left: 6px solid rgb(172, 169, 5);
      background-color: rgb(255, 255, 230);
    }

    &.card-status-2 {
      border: 1px solid rgb(11, 199, 105);
      border-left: 6px solid rgb(11, 199, 105);
      background-color: rgb(233, 247, 240);
    }

    &.card-status-4 {
      border: 1px solid rgb(192, 8, 8);
      border-left: 6px solid rgb(192, 8, 8);
      background-color: rgb(249, 242, 242);
    }

    &.card-past {
      border: 1px solid rgb(217, 217, 217);
      border-left: 6px solid rgb(217, 217, 217);
      background-color: #f0f2f5;

      &.card-status-1 {
        border: 1px solid rgb(172, 169, 5);
        border-left: 6px solid rgb(172, 169, 5);
        background-color: rgb(249, 249, 249);
      }

      &.card-status-2 {
        border: 1px solid rgb(11, 199, 105);
        border-left: 6px solid rgb(11, 199, 105);
        background-color: rgb(249, 249, 249);
      }

      &.card-status-4 {
        border: 1px solid rgb(192, 8, 8);
        border-left: 6px solid rgb(192, 8, 8);
        background-color: rgb(249, 249, 249);
      }
    }

    &.selected {
      background-color: #99d348;
    }

    &.selected-continuos {
      background-color: #99d348;
    }

    &.is-now {
      background-color: '#dddf65';
    }
  }
`
